import { recordPath, recordRoute } from '@/shared/registry'

/** Where the subscription pages live. */
export const subscriptionsPath = '/entitlements/subscriptions'
export const createSubscriptionPath = `${subscriptionsPath}/new`
export const createPathSubscriptionPath = `${subscriptionsPath}/new-learning-path`
export const subscriptionRoute = recordRoute('entitlements', 'subscriptions')
export const editSubscriptionRoute = `${subscriptionRoute}/edit`

/** A subscription's details page. */
export function subscriptionPath(id: string): string {
  return recordPath('entitlements', 'subscriptions', id)
}

/** A subscription's edit page. */
export function editSubscriptionPath(id: string): string {
  return `${subscriptionPath(id)}/edit`
}

/** Find Subscriptions showing one person's, as User Details links to it. */
export function personSubscriptionsPath(userId: string): string {
  return `${subscriptionsPath}?${new URLSearchParams({ filter: `userId:equals:${userId}` }).toString()}`
}

/** Create Subscription with one person already chosen, as User Details links to it. */
export function createPersonSubscriptionPath(userId: string): string {
  return `${createSubscriptionPath}?${new URLSearchParams({ userId }).toString()}`
}

/** The base of Subscription Details' slots (`detailsSlots`). */
export const subscriptionDetailsSlot = 'entitlements.subscription-details'

/** The permissions the subscription screens show or hide their actions and fields by. */
export const readSubscriptionsPermission = 'entitlements.subscriptions.read'
export const writeSubscriptionsPermission = 'entitlements.subscriptions.write'
export const deleteSubscriptionsPermission = 'entitlements.subscriptions.delete'
export const endDateSubscriptionsPermission = 'entitlements.subscriptions.end-date.write'
export const priceSubscriptionsPermission = 'entitlements.subscriptions.price.write'

/** The API's subscription endpoints. */
export const subscriptionsApi = '/entitlements/v1/subscriptions'
export const subscriptionGrantsApi = '/entitlements/v1/subscriptions/bulk'

export function subscriptionApi(id: string): string {
  return `${subscriptionsApi}/${encodeURIComponent(id)}`
}
